import * as React from 'react';
import featuredProductsServiceInstance from '../../services/products/FeaturedProductsService';
import listService from 'src/services/lists/ListsService';
import './FeaturedProductsCarousel.scss';

import ProductModel from '../../model/product.model';
import ProductCard from '../ProductCard/ProductCard';
import CarouselContainer from '../common/CarouselContainer';
import { ifLoggedIn, goToPartDetail } from 'src/utils/navigation';
import i18n from 'src/translation/i18n';
import { analyticsListNames } from 'src/analytics/constant';

interface IFeaturedProductsCarouselState {
  isLoading: boolean;
  products: ProductModel[];
}

export class FeaturedProductsCarousel extends React.Component<
  any,
  IFeaturedProductsCarouselState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      products: []
    };
  }
  public handleBuyNow = (productId: string) => {
    const productClicked = this.state.products.find(
      product =>
        `${product.manufacturerCode}  ${product.productNumber}` === productId
    );
    productClicked['position'] =
      this.state.products.indexOf(productClicked) + 1;
    this.props.fireProductClickEvent({
      product: productClicked,
      list: analyticsListNames.FEATURED_PRODUCTS
    });
    ifLoggedIn(() => goToPartDetail(productId));
  };
  private getProducts = () => {
    featuredProductsServiceInstance.getProducts().then(res => {
      this.setState({
        isLoading: false,
        products: res
      });
      this.fireProductImpressionAnalytics();
    });
  };
  private handleToggleFavorite = (
    name: string,
    category:string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    if (favorite) {
      listService.deleteItem(favoriteId).then(res => this.getProducts());
    } else {
      if(category?.trim() === "WSER") {
        goToPartDetail(`${mfc}  ${name}`);
        return;
      }
      listService
        .addItem('favorites', name, mfc)
        .then(res => this.getProducts());
    }
  };

  private reloadList = () => {
    this.getProducts();
  };

  public componentDidMount() {
    this.getProducts();
  }

  private fireProductImpressionAnalytics = () => {
    if (this.props.fireProductImpressionEvent) {
      this.props.fireProductImpressionEvent({
        products: this.state.products,
        list: analyticsListNames.FEATURED_PRODUCTS
      });
    }
  };

  public render() {
    return (
      <div className="rp-featured-products-cards-carousel">
        <div className="rp-featured-text">
          {i18n.t('common.featuredProducts')}
        </div>
        <CarouselContainer loading={this.state.isLoading}>
          {this.state.products.length > 0 &&
            this.state.products.map((product, index) => (
              <ProductCard
                key={index}
                part={product}
                id={product.productNumber}
                name={product.productNumber}
                category={product.category}
                mfc={product.manufacturerCode}
                description={product.description}
                price={product.partnerPrice}
                msrp={product.retailPrice}
                image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                handleOnClicBuyNow={this.handleBuyNow}
                handleToggleFavorite={this.handleToggleFavorite}
                inStock={product.inStock}
                favorite={product.favorite}
                favoriteId={product.idFavoriteItem}
                deal={!!product.discountInfo}
                state={product.state}
                stateDescription={product.stateDescription}
                reloadPart={this.reloadList}
              />
            ))}
        </CarouselContainer>
      </div>
    );
  }
}

export default FeaturedProductsCarousel;
